import {
  MANAGER_LAYOUT_PATHS,
  managerCovenantsNavigationConfig,
  managerGuaranteesNavigationConfig,
  managerSecondaryNavigationConfig,
  managerTopLevelNavigationConfig,
} from './constants.ts';
import type {
  IBuildGuaranteesNavigationParams,
  TGuaranteesBreadcrumbItem,
  TGuaranteesNavigationItem,
} from './types.ts';
import { buildVisibleNavigationItems } from './utils.ts';

export const buildManagerNavigation = (
  visibilityMap: IBuildGuaranteesNavigationParams
): TGuaranteesNavigationItem[] => {
  const topLevelItems = buildVisibleNavigationItems(managerTopLevelNavigationConfig, visibilityMap);
  const covenantChildren = buildVisibleNavigationItems(
    managerCovenantsNavigationConfig,
    visibilityMap
  );
  const covenantGroup: TGuaranteesNavigationItem[] = covenantChildren.length
    ? [
        {
          segment: 'covenants',
          pattern: 'covenants{/:segment}*',
          title: 'Ковенанти',
          children: covenantChildren,
        },
      ]
    : [];
  const guaranteeChildren = buildVisibleNavigationItems(
    managerGuaranteesNavigationConfig,
    visibilityMap
  );
  const guaranteeGroup: TGuaranteesNavigationItem[] = guaranteeChildren.length
    ? [
        {
          segment: 'guarantees',
          pattern: 'guarantees{/:segment}*',
          title: 'Гарантії',
          children: guaranteeChildren,
        },
      ]
    : [];
  const secondaryItems = buildVisibleNavigationItems(
    managerSecondaryNavigationConfig,
    visibilityMap
  );

  return [...topLevelItems, ...covenantGroup, ...guaranteeGroup, ...secondaryItems];
};

export const getManagerLayoutBreadcrumbs = (pathname: string): TGuaranteesBreadcrumbItem[] => {
  if (
    pathname === MANAGER_LAYOUT_PATHS.guaranteesStart ||
    pathname === MANAGER_LAYOUT_PATHS.guaranteesAdministratorStart
  ) {
    return [
      { label: 'Головна', path: MANAGER_LAYOUT_PATHS.home },
      { label: 'Гарантії', path: MANAGER_LAYOUT_PATHS.guaranteesStart },
      { label: 'Вибір контрагента' },
    ];
  }

  if (MANAGER_LAYOUT_PATHS.guaranteesClientPagePattern.test(pathname)) {
    return [
      { label: 'Головна', path: MANAGER_LAYOUT_PATHS.home },
      { label: 'Гарантії', path: MANAGER_LAYOUT_PATHS.guaranteesStart },
      { label: 'Сторінка клієнта' },
    ];
  }

  if (MANAGER_LAYOUT_PATHS.guaranteesApplicationPagePattern.test(pathname)) {
    return [
      { label: 'Головна', path: MANAGER_LAYOUT_PATHS.home },
      { label: 'Гарантії', path: MANAGER_LAYOUT_PATHS.guaranteesStart },
      { label: 'Заявка на гарантію' },
    ];
  }

  if (pathname === MANAGER_LAYOUT_PATHS.tasks) {
    return [{ label: 'Головна', path: MANAGER_LAYOUT_PATHS.home }, { label: 'Мої Завдання' }];
  }

  return [{ label: 'Головна', path: MANAGER_LAYOUT_PATHS.home }];
};
